import { IconButton, IconButtonProps } from '@chakra-ui/react';

export const ButtonIcon = ({ children, ...props }: IconButtonProps) => {
  return (
    <IconButton variant={props.color ? 'solid' : 'ghost'} size="sm" {...props}>
      {children}
    </IconButton>
  );
};
